/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_See_On_NotesInputs */

const en_dialog_see_on_notes = /** @type {(inputs: Dialog_See_On_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See on notes`)
};

const es_dialog_see_on_notes = /** @type {(inputs: Dialog_See_On_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver en notas`)
};

/**
* | output |
* | --- |
* | "See on notes" |
*
* @param {Dialog_See_On_NotesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_see_on_notes = /** @type {((inputs?: Dialog_See_On_NotesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_See_On_NotesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_see_on_notes(inputs)
	return en_dialog_see_on_notes(inputs)
});